/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/store/actions/projects.actions.js
 * File: projects.actions.js
 * Created Date: Sunday, January 27th 2019, 7:14:05 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Wed Mar 06 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import { resolveProjects, resolveProjectConfig } from 'client/app/services/project.service'

export const GET_PROJECT_DATA = '[PROJECT] GET PROJECT DATA'
export const GET_PROJECT_DATA_SUCCESS = '[PROJECT] GET PROJECT DATA SUCCESS'
export const GET_PROJECT_DATA_FAILURE = '[PROJECT] GET PROJECT DATA FAILURE'

export const GET_PROJECT_CONFIG_DATA = '[PROJECT] GET PROJECT CONFIG DATA'
export const GET_PROJECT_CONFIG_DATA_SUCCESS = '[PROJECT] GET PROJECT CONFIG DATA SUCCESS'
export const GET_PROJECT_CONFIG_DATA_FAILURE = '[PROJECT] GET PROJECT CONFIG DATA FAILURE'

export function getProjectsData (event) {
  return (dispatch, getState) => {
    dispatch(dataRequest(GET_PROJECT_DATA))
    return resolveProjects()
      .then(response => {
        dispatch(dataSuccess(GET_PROJECT_DATA_SUCCESS, response))
        return (response)
      })
      .catch(err => {
        dispatch(dataFail(GET_PROJECT_DATA_FAILURE, err))
        return (err)
      })
  }
}

export function getProjectConfig (id, token) {
  return (dispatch, getState) => {
    dispatch(dataRequest(GET_PROJECT_CONFIG_DATA))
    return resolveProjectConfig(token)
      .then(response => {
        dispatch(configDataSuccess(id, response))
        return (response)
      })
      .catch(err => {
        dispatch(dataFail(GET_PROJECT_CONFIG_DATA_FAILURE, err))
        return (err)
      })
  }
}

function dataRequest (type) {
  return {
    type
  }
}

function dataSuccess (type, data = {}) {
  return {
    type,
    data
  }
}

function dataFail (type, error) {
  return {
    type,
    error
  }
}

function configDataSuccess (id, configs) {
  return {
    type: GET_PROJECT_CONFIG_DATA_SUCCESS,
    data: {
      id,
      ...configs
    }
  }
}
